import { socket_url } from "./apiUtils";
import { createCustomerSocket } from "./socketConfig";

const socket = createCustomerSocket(socket_url, {
  autoConnect: false,
});

export default socket;
